import { useEffect, useMemo, useState } from "react";
import "./App.css";
import axios from "axios";

const API_BASE = "https://front-api.tteld.com";

function App() {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const nativeApp = data?.native;
  const android7App = data?.android7;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE}/api/apps/last-app`);
        setData(response.data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const noteList = useMemo(() => {
    const note = nativeApp?.note;
    if (!note) return [];
    return note
      .split("\r\n")
      .filter((line) => line.trim() !== "")
      .map((item) => item.replace(/^- /, ""));
  }, [nativeApp?.note]);

  const togleOpen = () => setIsOpen((v) => !v);

  if (loading) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }

  if (error) {
    // return <div>Error: {error.message}</div>;
  }

  const handleDownload = async () => {
    if (!nativeApp?.id || !nativeApp?.link) {
      console.error("Invalid native data for download");
      return;
    }

    const postUrl = `${API_BASE}/api/apps/downloads-up/${nativeApp.id}`;
    const fileUrl = `${API_BASE}/${nativeApp.link}`;

    try {
      await axios.post(postUrl);

      const anchor = document.createElement("a");
      anchor.href = fileUrl;
      anchor.download = "tteld.apk";
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
    } catch (error) {
      console.error("Error during the download process:", error);
    }
  };

  const downloadAndroid7Apk = async () => {
    if (!android7App?.link) {
      console.error("Android7 APK link not found");
      return;
    }

    // downloads-up bo‘lsa sanab qo‘yamiz (fail bo‘lsa ham download ketsin)
    try {
      if (android7App?.id) {
        await axios.post(`${API_BASE}/api/apps/downloads-up/${android7App.id}`);
      }
    } catch (e) {
      console.warn("Android7 downloads-up failed:", e);
    }

    const fileUrl = `${API_BASE}/${android7App.link}`;

    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = "tteld-android7.apk";
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <div className="card">
      <img src="/TT-ELD.svg" className="app-icon" />

      <h2 className="version-text">App version: {nativeApp?.appVersion}</h2>

      <div className="section">
        <h3 className="section-title">What’s new</h3>
        <ul className="feature-list">
          {noteList.map((line, index) => (
            <li key={index}>{line}</li>
          ))}
        </ul>
      </div>

      <div className="btn-border">
        <button className="primary-btn" onClick={handleDownload}>
          Download App
        </button>
      </div>

      <p className="note-text">
        For devices running <strong>Android 7</strong> or below, a compatible
        version of the app is available via the button below.
      </p>

      <button className="secondary-btn" onClick={downloadAndroid7Apk}>
        Download App
      </button>

      <div className="others" onClick={togleOpen}>
        Other links
      </div>

      {isOpen ? (
        <>
          <a
            className="box"
            href="https://apps.apple.com/uz/app/tt-eld/id1596279099"
            target="_blank"
            rel="noreferrer"
          >
            TT ELD <span className="middle">iOS</span> app download
          </a>

          <a
            className="box"
            href="https://apps.apple.com/uz/app/tt-eld/id1596279099"
            target="_blank"
            rel="noreferrer"
          >
            IOSIX update <span className="middle">APK</span>
          </a>

          {products.map((item) => (
            <a
              key={item.id}
              className="box"
              href={item.path}
              target="_blank"
              rel="noreferrer"
            >
              {item.name2}
            </a>
          ))}
        </>
      ) : null}
    </div>
  );
}

export default App;

const products = [
  {
    id: 4,
    name2: "TT ELD Sticker ",
    path: "https://us.tteld.com/docs/sticker.png",
    title:
      "A simple sticker can help roadside or enforcement personnel quickly ascertain that the device on board is in fact an ELD and carry out the inspection accordingly.",
    price: "Download",
  },
  {
    id: 5,
    name2: "Certificate",
    path: "https://us.tteld.com/docs/Certificate.pdf",
    title: "TT ELD is certified for customers confidence and safety",
    price: "Download",
  },
  {
    id: 6,
    name2: "Inspection ",
    path: "https://us.tteld.com/docs/Inspection.pdf",
    title: "Step by step guid for drivers during inspection",
    price: "Download",
  },
  {
    id: 7,
    name2: "Users manual",
    title:
      "The source for both drivers and dispatchers to guide while using TT ELD",
    price: "Download",
    path: "https://us.tteld.com/docs/Usersmanual.pdf",
  },
  {
    id: 8,
    name2: "Installation",
    title:
      "Quick instruction to setup both driver application and eld device before using TT ELD",
    price: "Download",
    path: "https://us.tteld.com/docs/Setup.pdf",
  },
  {
    id: 9,
    name2: "Malfunction",
    title: "The guide when eld or driver application does not work as intended",
    price: "Download",
    path: "https://us.tteld.com/docs/EldMalfunction.pdf",
  },
];
